
<div>
  <template v-for="propInput in section.properties">
    <dynamic-input-prop-data
        :key="`${propInput.id}-${dropdownControlId}`"
        :handler="handler"
        :q="q"
        :dynamic-input-prop="propInput"
        :path="completePathFor(propInput)"
        :parent-tree-context="parentTreeContext"
        @select="select"
    ></dynamic-input-prop-data>
  </template>

  <template v-for="objInput in section.objects">
    <dynamic-input-object-data
        :key="`${objInput.id}-${dropdownControlId}`"
        :handler="handler"
        :q="q"
        :dynamic-input-object="objInput"
        :path="completePathFor(objInput)"
        :parent-tree-context="parentTreeContext"
        @select="select"
    ></dynamic-input-object-data>
  </template>
</div>
